export default "__VITE_ASSET__DvKa2XyW__"